var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.0396H11.586L20.586 6.03956L18 3.45356L9 12.4536V15.0396ZM18.707 1.33256L22.707 5.33256C23.098 5.72356 23.098 6.35556 22.707 6.74656L12.707 16.7466C12.52 16.9346 12.265 17.0396 12 17.0396H8C7.448 17.0396 7 16.5926 7 16.0396V12.0396C7 11.7746 7.106 11.5196 7.293 11.3326L17.293 1.33256C17.684 0.941557 18.316 0.941557 18.707 1.33256ZM19 14.6998C19 14.1468 19.447 13.6998 20 13.6998C20.553 13.6998 21 14.1468 21 14.6998V20.0398C21 21.6938 19.654 23.0398 18 23.0398H4C2.346 23.0398 1 21.6938 1 20.0398V6.03976C1 4.38576 2.346 3.03976 4 3.03976H9.34C9.892 3.03976 10.34 3.48776 10.34 4.03976C10.34 4.59176 9.892 5.03976 9.34 5.03976H4C3.449 5.03976 3 5.48876 3 6.03976V20.0398C3 20.5918 3.449 21.0398 4 21.0398H18C18.552 21.0398 19 20.5918 19 20.0398V14.6998Z",
    fill: "#69B5B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.dcddba21125ce17c91d3a234af2e09fe.svg";
export { ForwardRef as ReactComponent };